export default {"src":"/_next/static/media/grant-rounded.30ea0a72.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};